module.exports = __webpack_public_path__ + "static/media/cpl_logo.c24cc9bd.png";